export enum AdminActionType {
    ViewAdminDetails = 0,
    ViewAdminRoles = 1,
    ResetPassword = 2,
    Lockout = 3,
    Delete = 4,
}
